import { readItem } from '@directus/sdk';
import { useQuery } from '@tanstack/react-query';

import { directusClient } from '../../services/directusClient/directusClient.ts';

export const useVenueItemQuery = (key?: string) =>
  useQuery({
    enabled: !!key,
    queryKey: ['venues', { key }],
    queryFn: async () => directusClient.request(readItem('venues', key ?? '')),
  });
